import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SkeletonLineDriver extends BaseUniDriver {}

export const skeletonLineDriverFactory = (
  base: UniDriver,
): SkeletonLineDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
